
import Vue from 'vue'

enum AlertTypes {
  warning = 'warning',
  error = 'error',
}

export default Vue.extend({
  name: 'serverErrors',
  props: {
    items: {
      type: Array,
      required: true
    },
    blockTitle: {
      type: String,
      required: true
    },
    alertType: {
      type: String,
      default: 'error'
    }
  },
  computed: {
    typeClass (): string {
      const vm = this as any
      return 'serverErrors--' + vm.alertType
    },
    getCurrentIcon (): string {
      const vm = this as any
      switch (vm.alertType) {
        case (AlertTypes.warning): return ''
        case (AlertTypes.error): return ''
        default: return ''
      }
    },
    getCurrentColor (): string {
      const vm = this as any
      switch (vm.alertType) {
        case (AlertTypes.warning): return vm.getColor('ACCENT.YELLOW')
        case (AlertTypes.error): return vm.getColor('ACCENT.RED_LIGHT')
        default: return ''
      }
    }
  }
})
